import { render, staticRenderFns } from "./team_member.vue?vue&type=template&id=59796167&scoped=true&"
import script from "./team_member.vue?vue&type=script&lang=js&"
export * from "./team_member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59796167",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59796167')) {
      api.createRecord('59796167', component.options)
    } else {
      api.reload('59796167', component.options)
    }
    module.hot.accept("./team_member.vue?vue&type=template&id=59796167&scoped=true&", function () {
      api.rerender('59796167', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/queue_manage/form/team_member.vue"
export default component.exports